import { AppBarData } from "@/appBar/appBarDomain";
import { EventDispatcher, navigate } from "@/events/eventsDomain";
import { changeLanguageAction } from "@/i18n/i18nDomain";
import { Language } from "@/i18n/languages";
import { TMessage } from "@/i18n/tt";
import {
  dcompanyFrontpageUrl,
  giveUsFeedbackUrl,
  loginUrl,
  portfolioUrl,
} from "@/utils/navigation";
import { LandingPageHeaderProps } from "./landingPageComponents";

// TODO Change useAppBar to also work in non-loggedin context
export const prepLandingPageHeader = ({
  appBar,
  user,
  lang,
  title,
  companyContext,
  dispatch,
}: {
  appBar: AppBarData | null;
  user?: { name: string; initials: string; email?: string };
  lang: Language;
  title?: TMessage;
  companyContext?: LandingPageHeaderProps["companyContext"];
  dispatch: EventDispatcher;
}): LandingPageHeaderProps => ({
  logoLinkUrl: appBar?.user ? portfolioUrl : dcompanyFrontpageUrl(lang),
  title,
  companyContext,
  userContext: user
    ? {
        title: { translated: user.name },
        subtitle: user.email ? { translated: user.email } : undefined,
      }
    : undefined,
  userMenu:
    appBar ??
    (user
      ? {
          languages: Object.values(Language).map((l) => ({
            language: l,
            isSelected: l === lang,
          })),
          actions: {
            logIn: () => dispatch([navigate(loginUrl())]),
            about: () => dispatch([navigate(dcompanyFrontpageUrl(lang), { newWindow: true })]),
            changeLanguage: (l) => dispatch(changeLanguageAction(l)),
            navigateToFeedback: () =>
              dispatch([{ type: "load-url", url: giveUsFeedbackUrl, newWindow: true }]),
          },
          portfolioUrl: portfolioUrl,
          user,
        }
      : undefined),
});
